(function($) {
    var frontpageNum1 = { var: 0 };
	var frontpageNum2 = { var: 0 };
	var frontpageNum3 = { var: 0 };

    var $grid;

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function deleteCookie(name) {
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    }

    function toggleMenu() {
        $('.hamburger.menuopen').toggleClass('is-active');
		$('#off-canvas').fadeToggle("fast", "swing");
       		
        hasScroll = window.innerWidth - document.documentElement.clientWidth;
        if($('.hamburger.menuopen').hasClass('is-active')) {
			$('#masthead').css('padding-right', hasScroll +'px');
			$('body').css('padding-right', hasScroll +'px');
			$('.offcanvascontent').css('margin-right', hasScroll +'px');
			$('body').toggleClass("overflow-hidden");
        } else {
			$('#masthead').css('padding-right', 0 +'px');
			$('body').css('padding-right', 0 +'px');
			$('body').toggleClass("overflow-hidden");
            //$('.offcanvascontent').css('margin-right', 0 +'px');
		}
        
        /* mark the active page */
        if ($('.navbar li.current_page_item').length > 0) {
            $('#navbar-line').css({top: ($('.navbar li.current_page_item').position().top + $('.navbar li.current_page_item').outerHeight()/2) + 'px'});
        } 
        //$('.hamburger-box img').toggleClass("opacity-0 opacity-100");
    }

    function changeNumber(el, num) {
        console.log(num.var);
		el.html((num.var).toFixed());
	}

    function numbersAddChart(id, fillvalue) {
        var chart = new Chartist.Pie(id, {
            series: [{
                className: 'ct-fillbar', 
                data: fillvalue
            },
            {
                className: 'ct-basebar',
                data: 100 - fillvalue
            }],
            }, {
                donut: true,
                startAngle: 0,
                showLabel: true,
                labelInterpolationFnc: function (value) {
                    return (value) + '%';
                }
        });
            
        chart.on('draw', (data) => {
            if (data.type === 'label' && data.index === 1) {
                data.element.remove();
            } 
            else if (data.type === 'label') {        
                const node = data.element.getNode();
                const svgElement = data.group.getNode().viewportElement;
                node.setAttribute('dx', svgElement.clientWidth / 2);
                node.setAttribute('dy', svgElement.clientHeight / 2);
            }
        });
    }
    function numbersAddChartMultiple(id, fillvalue) {
        var chart = new Chartist.Pie(id, {
            series: [{
                className: 'ct-fillbar data-0', 
                data: 20,
                meta: "Pension"
            },
            {
                className: 'ct-fillbar-blue data-1',
                data: 30,
                meta: "Life insurance"
            },
            {
                className: 'ct-fillbar-orange data-2',
                data: 50,
                meta: "Foundations"
            }],
            },
             {
                donut: true,
                chartPadding: 50,
                startAngle: 0,
                showLabel: true,
                textAnchor: 'middle',
                labelOffset: 50,
                 labelDirection: 'explode',
                 labelInterpolationFnc: function (value) {
                    return (value) + '%';
                } 
        });
            
        chart.on('draw', (data) => {
            /* if (data.type === 'label' && data.index === 1) {
                data.element.remove();
            } 
            else */if (data.type === 'label') {        
                const node = data.element.getNode();
                const svgElement = data.group.getNode().viewportElement;
                node.classList.add('absolute', 'opacity-0', 'label-'+data.index); 
                node.setAttribute('dx', svgElement.clientWidth / 2);
                node.setAttribute('dy', svgElement.clientHeight / 2);
            } 
        });
    }
    
    function numbersAddTimeline(gsap, i) {
        const tl = gsap.timeline();
        if (i != 1) {
            tl.from('#numbers' + i, {yPercent: 25, opacity: 0, duration: 1});
        }
    
        tl
            .from('#numbers' + i + ' .numbers-text', {yPercent: 25, opacity: 0, duration: 0.25})
            .from('#numbers' + i + ' .numbers-desc', {yPercent: 25, opacity: 0, duration: 0.25}, '-=0.125')
            .to('#numbers' + i, {opacity: 0, duration: 0.5, delay: 1});
    
        return tl;
    }
    
    function initBannerScroll() {
        gsap.registerPlugin(ScrollTrigger);
        $('.banner').each(function() {
            //bannerTop = $(this).attr('data-top');
            var bannerTop = $(this).find('.banner-overlay').outerHeight()-140;
            if ($(window).width() < 768) {
                bannerTop = 100;
            }
            var bannerId = $(this).attr('id');
            const tl = gsap.timeline();
            tl
                .to('#' + bannerId + ' .banner-overlay', {marginTop: -bannerTop, duration: 2, ease: "expo", onComplete:function(){ScrollTrigger.refresh()}});

            ScrollTrigger.create({
                animation: tl,
                trigger: '#' + bannerId,
                start: "top 30%",
                scrub: false,
                markers: WEBBIUM_JS.gsap_markers,
            });
        });
    }

    function initNav() {
        if ($('#masthead').length > 0) {
            /* set menu to dark if first section is dark and page still not scrolled */
            if($(window).scrollTop().valueOf() <= 0) {
                if( $('section').first().hasClass("dark") ) {
                    $('#masthead').addClass("dark");
                }
            } else {
                $('#masthead').removeClass("init");
            }

            /* hover for navbar */
            $('.navbar li a').hover(function() {
                $('#navbar-line').css({top: ($(this).position().top + $(this).outerHeight()/2) + 'px'});
            });

        // $('.navbar li a').first().trigger('hover');

            /* hover for navtop */
            $('.navtop li a').hover(function() {
                $('#navtop-line').css({opacity:100,left: ($(this).position().left + $(this).outerWidth()/2 - 12) + 'px'});
                //console.log("left:" + ($(this).position().left + $(this).outerWidth()/2 - 12) + 'px');
            });
            //initiate menu 
            if($('.navtop li.current_page_item a').length) {
                $('#navtop-line').css({opacity: 100,left: ($('.navtop li.current_page_item a').position().left + $('.navtop li.current_page_item a').outerWidth()/2 - 12) + 'px'});
                //console.log("left:" + ($('.navtop li.current_page_item a').position().left + $('.navtop li.current_page_item a').outerWidth()/2 - 12) + 'px');
            }

        // $('.navtop li a').trigger('hover');

            /* show / hide navigation on scroll */
            var position = $(window).scrollTop(); 
            var menuHeight = $('#masthead').outerHeight();
            var stickyOffset = $("#masthead").offset();
            var $contentDivs = $("section");

            $(window).scroll(function() {
                var scroll = $(window).scrollTop();
                // if not scrolled passed toparea
                if(position < 100) {
                    if( $('section').first().hasClass("dark") ) {
                        $('#masthead').addClass("dark");
                    }
                    $('#masthead').addClass("init");
                } else if((scroll > position) && position > 100) {  // if scrolled passed toparea going down
                    $('#masthead').css('top', -menuHeight + "px");
                    $('#masthead').removeClass('dark');
                } else { // if scrolling going up but not in top area
                    $('#masthead').removeClass('init');
                    $('#masthead').css('top', 0);
                }
                position = scroll;

                /* quick check if section is dark the show dark menu over that section */
                /*$contentDivs.each(function(k) {
                    var _thisOffset = $(this).offset();
                    var _actPosition = _thisOffset.top - $(window).scrollTop();
                    if (_actPosition < (stickyOffset.top + $('#masthead').height()/2) && _actPosition + $(this).height() - $('#masthead').height()/2 > 0) {
                        $("#masthead").removeClass("dark").addClass($(this).hasClass("dark") ? "dark" : "");
                        return false;
                    }
                });*/
            });

        }
    }

    function afterInvestmentsFilter() {
        if ($('.investment:visible').length == 0) {
            $('#no-match').show();
        }
        else {
            $('#no-match').hide();
        }
    }


    function initInvestmentsListings() {
        $grid = $('.masonry').isotope({
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
        });

        $grid.on('arrangeComplete', afterInvestmentsFilter);

        $('.filter-dropdown').click(function(e, init = false) {
            if (!init) {
                $(this).toggleClass('open close');
                //if open and mouse left dropdown; close it
                if($(this).hasClass("open")) {
                    $(this).mouseleave(function() {
                        $(this).removeClass('open').addClass("close");
                      });
                }    
            }
        });

        $('.filter-toggle').click(function() {
            $('.filter-dropdown-box').toggleClass('hidden');
        });

        $('.filter-dropdown .show').click(function(e, init = false) {
            $(this).parent().find('.show').removeClass('ischecked');
            $(this).addClass('ischecked');
            $(this).parent().addClass("close");
            if($(this).html() != "All") {
                setCookie('_adelis_investment_' + $(this).parent().parent().find('.filter-on').attr('data-value').toLowerCase(), $(this).attr('data-value'), 1);
                $(this).parent().parent().find('.filter-label').html($(this).parent().parent().find('.filter-on').attr('data-value'));
                $(this).parent().parent().find('.filter-on').html($(this).html());
            } else {
                setCookie('_adelis_investment_' + $(this).parent().parent().find('.filter-on').attr('data-value').toLowerCase(), null, 0);
                $(this).parent().parent().find('.filter-on').html($(this).parent().parent().find('.filter-on').attr('data-value'));
                $(this).parent().parent().find('.filter-label').html("");
            }
            $(this).parent().attr('data-value', $(this).attr('data-value'));

            // Construct classes
            var classes = '';
            $('.dropdown-menu').each(function() {
                value = $(this).attr('data-value');
                if (value) {
                    classes += '.' + $(this).attr('data-value');
                }
            });
            
            $('#masonry-filter').attr('data-value', classes);

            if ($('.investments.list').is(':hidden')) {
                $grid.isotope({filter: '.investment' + classes});
            }
            else {
                $('.investments.list .investment-list-item').hide();
                $('.investments.list .investment' + classes).show();
                afterInvestmentsFilter();
            }
        });
        
        $('.toggle').click(function() {
            $('.toggle.selected').removeClass('selected');
            $('.toggle.opacity-0').addClass('selected');
            $('.toggle.opacity-100').removeClass('opacity-100 translate-y-0').addClass('opacity-0 translate-y-6');
            $('.toggle.selected').removeClass('opacity-0 translate-y-6').addClass('opacity-100 translate-y-0');

            if ($('.investments.list').is(':visible')) {
                $('.investments.list').fadeOut(function() {
                    $grid.isotope({filter: $('#masonry-filter').attr('data-value')});
                });
            }

            else if ($('.investments.list').is(':hidden')) {
                $grid.isotope({filter: '-'});
                $('.investments.list .investment').hide();
                $('.investments.list .investment' + $('#masonry-filter').attr('data-value')).show();
                $('.investments.list').fadeIn();
            }
        });

        if (null !== (sector = getCookie('_adelis_investment_sector'))) {
            $('#' + sector).trigger('click', [true]);
        }

        if (null !== (country = getCookie('_adelis_investment_country'))) {
            $('#' + country).trigger('click', [true]);
        }

        if (null !== (status = getCookie('_adelis_investment_status'))) {
            $('#' + status).trigger('click', [true]);
        }

        if (null !== (year = getCookie('_adelis_investment_year'))) {
            $('#' + year).trigger('click', [true]);
        }

    }

    function initChart() {
        //console.log($('#chart-labels').attr('data-value'));
        var data = {
            // A labels array that can contain any sort of values
            labels: JSON.parse($('#chart-labels').html()),
            // Our series array that contains series objects or in this case series data arrays
            series: JSON.parse($('#chart-series').attr('data-value'))
        };
    
        var options = {
            grid: false,
            showPoint: true,
            // lineSmooth: Chartist.Interpolation.cardinal({
            //     tension: 1
            // }),
            fullWidth: true,
            axisX: {
                /* labelInterpolationFnc: function(value, index) {
                    return index % 2 === 0 ?  value : null;
                }, */
                labelOffset: {
                    x: -15, 
                    y: 20
                }
            },  
            axisY: {
                labelInterpolationFnc: function(value, index) {
                    return index % 2 === 0 ?  value : null;
                },
                labelOffset: {
                    x: -20,
                    y: 0
                }
            },
            chartPadding: {
                top: 15,
                right: 15,
                bottom: 5,
                left: 15
            },
            labelDirection: 'explode',
        
            plugins: [
                Chartist.plugins.ctPointLabels({
                    textAnchor: 'middle',
                    labelOffset: {
                        y: -20
                    },
                    /*labelInterpolationFnc: function(value, index) {
                    return index % 2 === 0 ? value : '';
                    }*/
                }),
                Chartist.plugins.ctAxisTitle({
                    // axisX: {
                    //     axisTitle: "Time",
                    //     axisClass: "ct-axis-title",
                    //     offset: {
                    //       x: 0,
                    //       y: 75
                    //     },
                    //     textAnchor: "middle"
                    //   },
                      axisY: {
                        axisTitle: " " +$('#chart-y-axis-title').attr('data-value'),
                        axisClass: "ct-axis-title",
                        offset: {
                          x: 0,
                          y: -25
                        },
                        textAnchor: "middle",
                        flipTitle: true
                      }
                })
                ]
        };
        var chart = new Chartist.Line('.ct-chart', data, options);
    
        var point = 0;
        var delay = 100;
        var duration = 300;
    
        chart.on('draw', function(data) {
            if (data.type == 'point') {
                data.element.animate({
                    x1: {
                        begin: point * delay,
                        dur: duration, 
                        from: data.x - 10,
                        to: data.x,
                        easing: 'easeOutQuart'
                    },
                    opacity: {
                        begin: point++ * delay,
                        dur: duration, 
                        from: 0,
                        to: 1,
                    }
                });
    
                point++;
            }
            
            else if(data.type === 'line') {
                data.element.animate({
                    opacity: {
                        // The delay when we like to start the animation
                        begin: 2000,
                        // Duration of the animation
                        dur: 1500,
                        // The value where the animation should start
                        from: 0,
                        // The value where it should end
                        to: 1
                    }
                });
            }
    
        });
    
        chart.on('created', function() {
            point = 0;
        });
    }
    

    function initHeaderFrontpage() {
        var frontpageHeaderSeries = $('#frontpage-header-series').attr('data-value');
        var data = {
            // A labels array that can contain any sort of values
            //labels: ['Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5'],
            // Our series array that contains series objects or in this case series data arrays
            series: JSON.parse(frontpageHeaderSeries)
        };
    
        var options = {
            grid: false,
            showPoint: true,
            fullWidth: true,
            axisX: {
                showLabel: false,
                showGrid: false,
                offset: 0,
                labelInterpolationFnc: function(value, index) {
                    return index % 4 === 0 ?  value : null;
                },
                labelOffset: {
                    x: 0, 
                    y: 20
                }
            },  
            axisY: {
                showLabel: false,
                showGrid: false,
                offset: 0
            },
            /* axisX: {
                showLabel: false,
                showGrid: false,
                offset: 0
            }, */
            chartPadding: {
                top: 15,
                right: 15,
                bottom: 5,
                left: 10
            },
            labelDirection: 'explode',
        
            plugins: [
                Chartist.plugins.ctPointLabels({
                textAnchor: 'middle',
                labelOffset: {
                    y: -30
                },
                labelInterpolationFnc: function(value, index) {
                    //console.log(data.series[0].length);
                    // Return first and last
                    if (index == 0) {
                        return '1x';
                    }
                    else if (index == data.series[0].length - 1) {
                        return $('#frontpage-header-growth').html() + 'x';
                    }
                    return (index == 0 || index == data.series[0].length - 1) ? value : '';
                    //return index % 2 === 0 ? value : '';
                }
                })
            ]
        };
        
        // Create a new line chart object where as first parameter we pass in a selector
        // that is resolving to our chart container element. The Second parameter
        // is the actual data object.
        var chart = new Chartist.Line('.header-chart', data, options);
    
        var point = 0;
        var delay = 100;
        var duration = 300;
    
        chart.on('draw', function(data) {
            //console.log(point);
            if (data.type == 'point') {
                data.element.animate({
                    x1: {
                        begin: point * delay,
                        dur: duration, 
                        from: data.x - 10,
                        to: data.x,
                        easing: 'easeOutQuart'
                    },
                    opacity: {
                        begin: point++ * delay,
                        dur: duration, 
                        from: 0,
                        to: 1,
                    }
                });
    
                point++;
            }
        
            else if(data.type === 'line') {
                data.element.animate({
                    opacity: {
                        // The delay when we like to start the animation
                        begin: 2000,
                        // Duration of the animation
                        dur: 1500,
                        // The value where the animation should start
                        from: 0,
                        // The value where it should end
                        to: 1
                    }
                });
    
                //console.log('Ready');
            }
        });
    
        chart.on('created', function() {
            point = 0;
        });
    }

    function countUp(el, current, max) {
        if (current <= max) {
            el.html((current++).toFixed());
            setTimeout(countUp, 20, el, current, max);
        }
    }

    function initContentInfocard() {
        frontpageNum1 = { var: 0 };
        frontpageNum2 = { var: 0 };
        frontpageNum3 = { var: 0 };
        
        gsap.registerPlugin(ScrollTrigger);
    
        const tl1 = gsap.timeline();
        tl1
            .from('#numbers1 .numbers-text', {yPercent: 25, opacity: 0, duration: 0.5})
            .to(frontpageNum1, {var: $('#numbers1 .numbers-text').attr('data-countup-number'), onStart: function() {
                if ($('#numbers1 .countup-number').html() == 0) {
                    countUp($('#numbers1 .countup-number'), frontpageNum1.var, $('#numbers1 .numbers-text').attr('data-countup-number'));
                }
            }})
            .from('#numbers1 .numbers-desc', {yPercent: 25, opacity: 0, duration: 0.25}, '-=0.75')
            .to('#numbers1', {scale: 0.75, opacity: 0, duration: 0.35, delay: 0});
    
        const tl2 = gsap.timeline();
        tl2
            .from('#numbers2', {yPercent: 25, opacity: 0, duration: 0.5})
            .from('#numbers2 .numbers-text', {yPercent: 25, opacity: 0, duration: 0.25})
            .to(frontpageNum2, {var: $('#numbers2 .numbers-text').attr('data-countup-number'), onStart: function() {
                if ($('#numbers2 .countup-number').html() == 0) {
                    countUp($('#numbers2 .countup-number'), frontpageNum2.var, $('#numbers2 .numbers-text').attr('data-countup-number'));
                }
            }})
            .from('#numbers2 .numbers-desc', {yPercent: 25, opacity: 0, duration: 0.25}, '-=0.75')
            .to('#numbers2', {scale: 0.75, opacity: 0, duration: 0.35, delay: 0});
            
        const tl3 = gsap.timeline();
        tl3
            .from('#numbers3', {yPercent: 25, opacity: 0, duration: 0.5})
            .from('#numbers3 .numbers-text', {yPercent: 25, opacity: 0, duration: 0.25})
            .to(frontpageNum3, {var: $('#numbers3 .numbers-text').attr('data-countup-number'), onStart: function() {
                if ($('#numbers3 .countup-number').html() == 0) {
                    countUp($('#numbers3 .countup-number'), frontpageNum3.var, $('#numbers3 .numbers-text').attr('data-countup-number'));
                }
            }})
            .from('#numbers3 .numbers-desc', {yPercent: 25, opacity: 0, duration: 0.25}, '-=0.75');
            //.to('#numbers3', {scale: 0.75, opacity: 0, duration: 0.5, delay: 1});
    
    
        const tllast = gsap.timeline();
        //if ($(window).width() >= 1024) {
            tllast
                .from('#numbers-last', {yPercent: 25, opacity: 0, duration: 0.5})
        //}
    
    
        let tl = gsap.timeline();
        tl.add(tl1, "-=0.5").add(tl2, '-=0.5').add(tl3, '-=0.5'); //.add(tllast, '-=0.5');
    
        ScrollTrigger.create({
            animation: tl,
            trigger: "#sticky-container",
            start: "top top",
            end: "+=4000", 
            scrub: true,
            pin: true,
            anticipatePin: 1,
            markers: WEBBIUM_JS.gsap_markers
        });
    }
    
    function afterCasesFilter() {
        if ($('.case:visible').length == 0) {
            $('#no-match').show();
        }
        else {
            $('#no-match').hide();
        }
    }

    function initCasesListings() {
        $grid = $('.masonry').isotope({
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
        });

        $grid.on('arrangeComplete', afterCasesFilter);

        $('.filter-dropdown').click(function(e, init = false) {
            if (!init) {
                $(this).toggleClass('open close');
                //if open and mouse left dropdown; close it
                if($(this).hasClass("open")) {
                    $(this).mouseleave(function() {
                        $(this).removeClass('open').addClass("close");
                      });
                }    
            }
        });
        
        $('.filter-toggle').click(function() {
            $('.filter-dropdown-box').toggleClass('hidden');
        });

        $('.filter-dropdown .show').click(function() {
            $(this).parent().find('.show').removeClass('ischecked');
            $(this).addClass('ischecked');
            $(this).parent().addClass("close");
            if($(this).html() != "All") {
                setCookie('_adelis_case_' + $(this).parent().parent().find('.filter-on').attr('data-value').toLowerCase(), $(this).attr('data-value'), 1);
                $(this).parent().parent().find('.filter-label').html($(this).parent().parent().find('.filter-on').attr('data-value'));
                $(this).parent().parent().find('.filter-on').html($(this).html());
            } else {
                setCookie('_adelis_case_' + $(this).parent().parent().find('.filter-on').attr('data-value').toLowerCase(), null, 1);
                $(this).parent().parent().find('.filter-on').html($(this).parent().parent().find('.filter-on').attr('data-value'));
                $(this).parent().parent().find('.filter-label').html("");
            }
            $(this).parent().attr('data-value', $(this).attr('data-value'));
            // Construct classes
            var classes = '';
            $('.dropdown-menu').each(function() {
                value = $(this).attr('data-value');
                if (value) {
                    classes += '.' + $(this).attr('data-value');
                }
            });
            
            $('#masonry-filter').attr('data-value', classes);
    
            if ($('.cases.list').is(':hidden')) {
                $grid.isotope({filter: '.case' + classes});
            }
            else {
                $('.cases.list .case-list-item').hide();
                $('.cases.list .case' + classes).show();
                afterCasesFilter();
            }
        });
    
        $('.toggle').click(function() {
            $('.toggle.selected').removeClass('selected');
            $('.toggle.opacity-0').addClass('selected');
            $('.toggle.opacity-100').removeClass('opacity-100 translate-y-0').addClass('opacity-0 translate-y-6');
            $('.toggle.selected').removeClass('opacity-0 translate-y-6').addClass('opacity-100 translate-y-0');
    
            if ($('.cases.list').is(':visible')) {
                $('.cases.list').fadeOut(function() {
                    $grid.isotope({filter: $('#masonry-filter').attr('data-value')});
                });
            }
    
            else if ($('.cases.list').is(':hidden')) {
                $grid.isotope({filter: '-'});
                $('.cases.list .case').hide();
                $('.cases.list .case' + $('#masonry-filter').attr('data-value')).show();
                $('.cases.list').fadeIn();
            }
        }); 

        if (null !== (sector = getCookie('_adelis_case_sector'))) {
            $('#' + sector).trigger('click', [true]);
        }

        if (null !== (country = getCookie('_adelis_case_country'))) {
            $('#' + country).trigger('click', [true]);
        }
    }
    
    function initNumbers() {
        var barColors = ['ct-fillbar-sea-blue', 'ct-fillbar', 'ct-fillbar-blue'];
        var series = [];
        var i = 0;
        $('.number-sections').each(function() {
            series.push({
                className: barColors[i++],
                data: $(this).attr('data-value')
            })
        });
    
        var chart = new Chartist.Pie('.ct-piechart', {
            series: series,
            }, {
                donut: true,
                startAngle: 0,
                showLabel: false
        });
    }
    
    function initTeam() {
        $grid = $('.masonry').isotope({
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
        });
        
        $('.toggle').click(function() {
            $('.toggle.selected').removeClass('selected');
            $('.toggle.opacity-0').addClass('selected');
            $('.toggle.opacity-100').removeClass('opacity-100 translate-y-0').addClass('opacity-0 translate-y-6');
            $('.toggle.selected').removeClass('opacity-0 translate-y-6').addClass('opacity-100 translate-y-0');
            if ($('.team.list').is(':visible')) {
                $('.team.list').fadeOut(function() {
                    $grid.isotope({filter: ''} );
                    });
            }
    
            else if ($('.team.list').is(':hidden')) {
                $grid.isotope({filter: '-'});
                $('.team.list').fadeIn();
            } 
        });
    }
    
    function initContact() {
        var $grid = $('.masonry').isotope({
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
        });
        
        $('.toggle').click(function() {
            //console.log('toggle');
            if ($('.team.list').is(':visible')) {
                $('.team.list').fadeOut(function() {
                    $grid.isotope({filter: ''} );
                    });
            }
    
            else if ($('.investments.list').is(':hidden')) {
                $grid.isotope({filter: '-'});
                $('.investments.list').fadeIn();
            } 
        });
    }

    function initPress() {
        $('.filter-dropdown').click(function() {
            $(this).toggleClass('open close');
            //if open and mouse left dropdown; close it
            if($(this).hasClass("open")) {
                $(this).mouseleave(function() {
                    $(this).removeClass('open').addClass("close");
                  });
            }
        });

        $('.filter-dropdown .show').click(function() {
            $(this).parent().find('.show').removeClass('ischecked');
            $(this).addClass('ischecked');
            $(this).parent().addClass("close");
            if($(this).html() != "All") {
                $(this).parent().parent().find('.filter-label').html($(this).parent().parent().find('.filter-on').attr('data-value'));
                $(this).parent().parent().find('.filter-on').html($(this).html());
            } else {
                $(this).parent().parent().find('.filter-on').html($(this).parent().parent().find('.filter-on').attr('data-value'));
                $(this).parent().parent().find('.filter-label').html("");
            }
            $(this).parent().attr('data-value', $(this).attr('data-value'));
    
            // Construct classes
            var classes = '';
            $('.dropdown-menu').each(function() {
                value = $(this).attr('data-value');
                if (value) {
                    classes += '.' + $(this).attr('data-value');
                }
            });
    
            $('.presslist .doc-item').hide();
            $('.presslist .doc-item' + classes).show();
        });
    }
    
    function initializeComponents() {
        // Update modal backlinks
        $('.backlink').each(function() {
            var prevPage = getCookie('_adelis_prev_page');
            if (!prevPage) {
                if ($('#app').attr('data-posttype') !== 'page' && $('#app').attr('data-page-for-posttype')) {
                    prevPage = $('#app').attr('data-page-for-posttype');
                }
                else {
                    prevPage = '/';
                }
            }

            if (prevPage == $('#app').attr('data-permalink')) {
                prevPage = '/';
            }
 
            $(this).attr('href', prevPage);
        });

        // Update cookies for modal
        if ($('#app').attr('data-posttype') == 'page') {
            setCookie('_adelis_prev_page', $('#app').attr('data-permalink'), 1);
        }

        $('#masthead').css('padding-right', 0 +'px');
        $('body').css('padding-right', 0 +'px');
        $('body').removeClass("overflow-hidden");

        window.dispatchEvent(new Event('resize')); 

        // Clear cookies
        if ($('.page-template-tpl-investments').length == 0 && $('.single-investments').length == 0) {
            setCookie('_adelis_investment_sector', null, 1);
            setCookie('_adelis_investment_country', null, 1);
            setCookie('_adelis_investment_year', null, 1);
            setCookie('_adelis_investment_status', null, 1);
        }

        if ($('.page-template-tpl-cases').length == 0 && $('.single-cases').length == 0) {
            setCookie('_adelis_case_sector', null, 1);
            setCookie('_adelis_case_country', null, 1);
        }

        // Navigation
        initNav();

        //
        // Page specific initialization, most functions are located in page templates and template parts
        // 
        if ($('#app.home').length > 0) {
            //console.log('initHome');
            // Frontpage init
            initHeaderFrontpage();
            initContentInfocard();
            initBannerScroll();
        }
        else if ($('#app.page-template-tpl-investments').length > 0) {
            //console.log('initInvestments');
            // Investments
            initInvestmentsListings();
        }
        else if ($('#app.page-template-tpl-cases').length > 0) {
            //console.log('initCase');
            initCasesListings();
        }
        else if ($('#app.page-template-tpl-about').length > 0) {
            //console.log('initAbout');
            initNumbers();
        }
        else if ($('#app.page-template-tpl-team').length > 0) {
            //console.log('initTeam');
            initTeam();
        }
        else if ($('#app.page-template-tpl-contact').length > 0) {
            //console.log('initContact');
            initContact();
        }
        else if ($('#app.blog').length > 0) {
            //console.log('initPress');
            initPress();
        }
        else if ($('#app.single-cases').length > 0) {
            //console.log('initSingleCase');
            initBannerScroll();
            initChart();
        }
        else {
            //console.log('Skipping initialization');
        }

        // 
        // General initilization
        //

        ScrollReveal().reveal('.scr', {
            'interval': 200,
            'scale': 0.8,
            'duration': 1000
        });
        ScrollReveal().reveal('.scr-nointerval', {
            'duration': 1000
        });
        ScrollReveal().reveal('.fullscr', {
            'interval': 200,
            'scale': 1,
            'duration': 1000
        });

        $('#toggle-off-canvas').click(toggleMenu);
        $('#toggle-off-canvas-open').click(toggleMenu);


        if ($('.usp-grid-item').length > 0) {
            $('.usp-grid-item').hover(function() {
                $('#usp-item-line').css({top: ($(this).position().top + $(this).find("h5").outerHeight()/2) + 'px'});
                let img = $(this).attr('data-name');
                if ($('#' + img).hasClass('opacity-0')) {
                    $('.opacity-100').removeClass('opacity-100 translate-y-0').addClass('opacity-0 translate-y-6');
                    $('#' + img).removeClass('opacity-0 translate-y-6').addClass('opacity-100 translate-y-0');
                }
            });    

            $('.usp-grid-item').first().trigger('hover');
        }

        if ($('.sidescroller').length > 0) {
            $('.sidescroller').slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                nextArrow: '<div class="scrollnavnext transition-all duration-500 transform z-30 absolute rounded-full h-16 w-16 flex flex-shrink-0 items-center justify-center top-1/2 -right-9 bg-blue bg-opacity-20"><img class="h-6 w-6 cursor-pointer" src="'+ WEBBIUM_JS.wp_template_directory_uri +'/assets/svg/icon-scroll-next-white.svg" /></div>',
                prevArrow: '<div class="scrollnavprev transition-all duration-500 transform z-30 absolute rounded-full h-16 w-16 flex flex-shrink-0 items-center justify-center top-1/2 -left-9 bg-blue bg-opacity-20"><img class="h-6 w-6 cursor-pointer" src="'+ WEBBIUM_JS.wp_template_directory_uri +'/assets/svg/icon-scroll-prev-white.svg" /></div>', 
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 885, 
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });    
        }

        // Cookiebanner
        $('.cookie-ok').click(function() {
            setCookie('_adelis_cookie_consent', true, 14);
            $('#adelis-cookie-consent').fadeOut();
        });
    }

    function reinitMasonry() {
        if ($('.masonry').length > 0) {
            $('.masonry').isotope();
        }
    }

    $(document).ready(function($) {
        //console.log('Document ready');
        // Only load swup if not logged in
        if ($('body.logged-in').length == 0) {
            const swup = new Swup({
                animationSelector: '[class*="swup-transition-"]',
                plugins: [
                    new SwupScrollPlugin({animateScroll: false})
                ]
            });    

            swup.on('contentReplaced', initializeComponents);
        }
 
        // Initialize components
        initializeComponents();
    });

    $(window).load(function() {
        if ($('.masonry').length > 0) {
            $('.masonry').isotope();
        }
    });
}(jQuery));
